import { BaseQueryApi, BaseQueryFn, createApi, DefinitionType, FetchArgs, fetchBaseQuery } from '@reduxjs/toolkit/query/react';
import axios from 'axios';
import { rustApiPath, TRustApiPath } from 'common/apiPath/rustApiPath';
import { RootState } from "../../redux/store";
import { setLogoutAction } from '../auth/actions';
import { authSlice } from '../auth/slice';
const { setLogin } = authSlice.actions
// Input type
export interface RustApiParams {
  params: object;
  urlObjKey: TRustApiPath;
}
const apiUrl = process.env.NODE_ENV === 'production' ? process.env.REACT_APP_BASE_URL : process.env.REACT_APP_DEV_BASE_API_URL;
// Base query without auth
const baseQuery = fetchBaseQuery({
  baseUrl: process.env.REACT_APP_RUST_API_URL,
   prepareHeaders: (headers, { getState }) => {
      const token = (getState() as RootState).auth?.profileData?.token;
      if (token) {
        headers.set("Authorization", `Bearer ${token}`);
      } else {
        console.warn("No token found. Request may fail.");
      }
      return headers;
    },
});

const baseQueryWithRefreshToken: BaseQueryFn<
  FetchArgs,
  BaseQueryApi,
  DefinitionType
> = async (args, api, extraOptions): Promise<any> => {
  const refreshToken = (api.getState() as RootState).auth?.profileData?.refreshToken;
  const encodedRefreshToken = encodeURIComponent(refreshToken)
  try {
    const result = await baseQuery(args, api, extraOptions);
    if (result?.error?.status === 401) {
      const res = await axios.get(`${apiUrl}/api/Auth/RefreshToken?token=${encodedRefreshToken}`)
      if (res.data?.token) {
        api.dispatch(setLogin({ token: res?.data?.token }));
        return await baseQuery(args, api, extraOptions);
      } else {
        api.dispatch(setLogoutAction());
      }
    }
    return result;
  } catch (error) {
    console.log("I am called!, Login action required")
    api.dispatch(setLogoutAction());
  }
};


export const rustApiCalling = createApi({
  reducerPath: 'rustBaseApi',
  baseQuery: baseQueryWithRefreshToken,
  tagTypes: ['rust'],
  keepUnusedDataFor: 0,
  refetchOnMountOrArgChange: true,
  refetchOnFocus: true,
  refetchOnReconnect: true,
  endpoints: (builder) => ({
    getData: builder.query<any, RustApiParams>({
      query: ({ params, urlObjKey }) => ({
        url: rustApiPath[urlObjKey],
        params,
      }),
    }),
    // Opt-in cached variant: same request, but the cache survives 60s after the last subscriber unmounts.
    // Use only where short-lived caching is desired (e.g. navigation round-trips).
    getDataCached: builder.query<any, RustApiParams>({
      query: ({ params, urlObjKey }) => ({
        url: rustApiPath[urlObjKey],
        params,
      }),
      keepUnusedDataFor: 60,
    }),
  }),
});

export const {
  useGetDataQuery: useRustGetDataQuery,
  useLazyGetDataQuery: useLazyRustGetDataQuery,
  useGetDataCachedQuery: useRustGetDataCachedQuery,
} = rustApiCalling;
